import { cn } from "@utils/tw"
import { ReactNode } from "react"
import { useIntersectionObserver } from "usehooks-ts"

export const Appear = ({
  delay,
  className,
  style,
  children,
  as = "div",
  slide = false,
  zoom = false,
  once = false,
  active = true,
  activeOnly = false,
  duration = 500,
  onClick,
}: {
  delay?: number
  className?: string
  style?: React.CSSProperties
  children: ReactNode
  as?: "div" | "p" | "span" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
  slide?: boolean
  zoom?: boolean
  once?: boolean
  active?: boolean
  activeOnly?: boolean
  duration?: number
  onClick?: () => void
}) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
    freezeOnceVisible: once,
  })
  const Component = as

  return (
    <Component
      ref={ref}
      className={cn(
        "transition-all opacity-0",
        slide && "translate-y-7",
        zoom && "scale-110",
        ((isIntersecting && active) || (activeOnly && active)) && "opacity-100 translate-y-0 scale-100",
        className,
      )}
      style={{
        transitionDelay: delay ? `${delay}ms` : undefined,
        transitionDuration: `${duration}ms`,
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </Component>
  )
}
